const state = {
  all: [],
}

const getters = {}

const actions = {
  getFloors ({ commit }, params) {
    axios
      .get("/admin/buildings/"+params.id+'/floors')
      .then(response => (commit('setData', response.data)));
  },
  getFloor ({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios
        .get("/admin/buildings/"+params.building_id+"/floors/"+params.floor_id, params)
        .then(response => {resolve(response)})
        .catch ( error => (reject(error)));
    })
  },
  addFloor ({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios
        .post("/admin/buildings/"+params.building_id+"/floors", params)
        .then(response => {resolve(response)})
        .catch ( error => (reject(error)));
    })
  },
  editFloor ({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios
        .put("/admin/buildings/"+params.building_id+"/floors/"+params.id, params)
        .then(response => {resolve(response)})
        .catch ( error => (reject(error)));
    })
  },
}

const mutations = {
  setData (state, data) {
    state.all = data.data;
  },
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
